export default __webpack_public_path__ + "static/media/find-a-match.e5f14135.svg";